import { createSlice } from '@reduxjs/toolkit'

// Slice
const initialProject = {
    project: {},
    sectionData: [],
    optionData: [],
    variationData: [],
    projectVariation: [],
    sectionVariation: [],
    projectcard: {},
    progresscard: {},
    financialCard: {},
    overviewCards: {},
    sections: {},
    variations: {},
    options: {},
    projectTotal: {},
    revisedProjectTotal: {},
    labors: [],
    userNames: [],
    subcontractors: []
};

const slice = createSlice({
    name: 'projectData',
    initialState: {
        ...initialProject,
    },
    reducers: {
        addProject: (state, action) => {
            state.project = {
                ...state.project,
                ...action.payload
            }
        },
        updateProject: (state, action) => {
            state.project = {
                ...state.project,
                ...action.payload
            }
        },
        addSectionData: (state, action) => {
            state.sectionData = action.payload;
        },
        addOptionData: (state, action) => {
            state.optionData = action.payload;
        },
        addVariationData: (state, action) => {
            state.variationData = action.payload;
        },
        addProjectVariation: (state, action) => {
            state.projectVariation = action.payload;
        },
        addSectionVariation: (state, action) => {
            state.sectionVariation = action.payload;
        },
        addProjectCard: (state, action) => {
            state.projectcard = action.payload;
        },
        addProgressCard: (state, action) => {
            state.progresscard = action.payload;
        },
        addFinancialCard: (state, action) => {
            state.financialCard = action.payload;
        },
        addOverviewCards: (state, action) => {
            state.overviewCards = action.payload;
        },
        addSections: (state, action) => {
            state.sections = action.payload;
        },
        addVariations: (state, action) => {
            state.variations = action.payload;
        },
        addOptions: (state, action) => {
            state.options = action.payload;
        },
        addProjectTotal: (state, action) => {
            state.projectTotal = action.payload;
        },
        addRevisedProjectTotal: (state, action) => {
            state.revisedProjectTotal = action.payload;
        },
        addLabor: (state, action) => {
            state.labors = action.payload
        },
        addUserNames: (state, action) => {
            state.userNames = action.payload
        },
        addSubcontractors: (state, action) => {
            state.subcontractors = action.payload
        },
        clearProject: (state) => {
            Object.assign(state, initialProject);
        }
    },
});

export default slice.reducer;

// Actions
const {
    addProject,
    updateProject,
    addSectionData,
    addOptionData,
    addVariationData,
    addProjectVariation,
    addSectionVariation,
    addProjectCard,
    addProgressCard,
    addFinancialCard,
    addOverviewCards,
    addSections,
    addVariations,
    addOptions,
    addProjectTotal,
    addRevisedProjectTotal,
    addLabor,
    addUserNames,
    addSubcontractors,
    clearProject
} = slice.actions;

export const addProjectAction = (data) => async dispatch => {
    try {
        dispatch(addProject({ ...data }));
    } catch (e) {
        return console.error(e);
    }
}

export const updateProjectAction = (data) => async dispatch => {
    try {
        dispatch(updateProject({ ...data }));
    } catch (e) {
        return console.error(e);
    }
}

export const addSectionDataAction = (data) => async dispatch => {
    try {
        dispatch(addSectionData(data));
    } catch (e) {
        return console.error(e);
    }
}
export const addOptionDataAction = (data) => async dispatch => {
    try {
        dispatch(addOptionData(data));
    } catch (e) {
        return console.error(e);
    }
}
export const addVariationDataAction = (data) => async dispatch => {
    try {
        dispatch(addVariationData(data));
    } catch (e) {
        return console.error(e);
    }
}

export const addProjectVariationAction = (data) => async dispatch => {
    try {
        dispatch(addProjectVariation(data));
    } catch (e) {
        return console.error(e);
    }
}

export const addSectionVariationAction = (data) => async dispatch => {
    try {
        dispatch(addSectionVariation(data));
    } catch (e) {
        return console.error(e);
    }
}

export const addProjectCardAction = (data) => async dispatch => {
    try {
        dispatch(addProjectCard(data));
    } catch (e) {
        return console.error(e);
    }
}

export const addProgressCardAction = (data) => async dispatch => {
    try {
        dispatch(addProgressCard(data));
    } catch (e) {
        return console.error(e);
    }
}

export const addFinancialCardAction = (data) => async dispatch => {
    try {
        dispatch(addFinancialCard(data));
    } catch (e) {
        return console.error(e);
    }
}

export const addOverviewCardsAction = (data) => async dispatch => {
    try {
        dispatch(addOverviewCards(data));
    } catch (e) {
        return console.error(e);
    }
}

export const addSectionsAction = (data) => async dispatch => {
    try {
        dispatch(addSections(data));
    } catch (e) {
        return console.error(e);
    }
}

export const addVariationsAction = (data) => async dispatch => {
    try {
        dispatch(addVariations(data));
    } catch (e) {
        return console.error(e);
    }
}

export const addOptionsAction = (data) => async dispatch => {
    try {
        dispatch(addOptions(data));
    } catch (e) {
        return console.error(e);
    }
}

export const addProjectTotalAction = (data) => async dispatch => {
    try {
        dispatch(addProjectTotal(data));
    } catch (e) {
        return console.error(e);
    }
}

export const addRevisedProjectTotalAction = (data) => async dispatch => {
    try {
        dispatch(addRevisedProjectTotal(data));
    } catch (e) {
        return console.error(e);
    }
}

export const addLevelAction = (data) => async dispatch => {
    try {
        dispatch(addLabor(data));
    } catch (e) {
        return console.error(e);
    }
}
export const addUserNamesAction = (data) => async dispatch => {
    try {
        dispatch(addUserNames(data));
    } catch (e) {
        return console.error(e);
    }
}

export const addSubcontractorsAction = (data) => async dispatch => {
    try {
        dispatch(addSubcontractors(data));
    } catch (e) {
        return console.error(e);
    }
}
export const clearProjectAction = () => async dispatch => {
    try {
        dispatch(clearProject());
    } catch (e) {
        return console.error(e);
    }
}